export const CONTACT = {
	email: 'rodrigoteytud1600@gmail.com',
	whatsapp: 'https://wa.me/524521450431',
	vantechUrl: 'https://www.vantechsolutions.mx',
}
